import React from 'react'

const SpaceComp = (props) => {
  return (
    <div style={{height:props.height, width:"98vw"}}>
    </div>
  )
}

export default SpaceComp
